import React from 'react'
import Link from 'gatsby-link'
import {
  Toolbar,
  Border,
  Image,
  Pre,
  Box,
  Flex,
  Text,
  Heading,
  NavLink,
} from 'rebass'
import Countdown from 'react-countdown-now'
import styled from 'styled-components'
import { sample, filter } from 'lodash'
import Img from 'gatsby-image'

import Newsletter from './Newsletter'
import MobileNav from './MobileNav'
// import logo from '../img/TNOC-Summit-logo.png'
import logo from '../img/TNOC-Summit.png'
import tnoclogo from '../img/tnoc-logo.png'
import tnocelogo from '../img/tnoce-logo.png'

// styles
const StyledLink = styled(Link)`
  font-size: ${props => (props.type === 'mobile' ? '1.5rem' : '0.875rem')};
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: inherit;
  padding: 0.25rem 1rem;
  &:disabled {
    opacity: 0.25;
  }
`
const StyledButton = styled.button`
  font-size: ${props => (props.type === 'mobile' ? '1.5rem' : '0.875rem')};
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: white;
  border: none;
  background: ${props => props.theme.colors.green};
  padding: 0.25rem 1rem;
  &:disabled {
    opacity: 0.25;
  }
`
const StyledPre = styled(Pre)`
  @media screen and (max-width: 50rem) {
    display: none;
  }
`

const TNOCFlex = styled(Flex)`
  span {
    font-size: 16px;
  }
  @media screen and (max-width: 75rem) {
    flex-direction: column;
    text-align: center;
    margin-left: 0;
  }
`

const LogoFlex = styled(Flex)`
  .gatsby-image-outer-wrapper {
    width: 100%;
    height: 100%;
  }
`

const DesktopToolbar = styled(Toolbar)`
  display: none;
  @media screen and (min-width: 60rem) {
    display: flex;
  }
`

const MobileHide = styled(Box)`
  @media screen and (min-width: 60rem) {
    display: none;
  }
`

const StyledBackgroundImg = styled.div`
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
  background: url(${props => props.src}) no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`

const StyledBackgroundImage = styled(Img)`
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
  background: url(${props => props.src}) no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`

const Overlay = styled(Box)`
  background-color: ${props => props.theme.colors.green};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.5;
`

const OverlayGradient = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: -1px;
  right: 0;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0) 30%
  );
`

class Navbar extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      rotating_images,
      tagline,
      menu,
      menuFr,
      location,
      switchLang,
      language,
    } = this.props

    return (
      <Box>
        <Border
          borderColor="#4BC169"
          borderLeft={0}
          borderRight={0}
          borderTop={0}
        >
          <DesktopToolbar
            px={4}
            bg="white"
            flexWrap="wrap"
            color="#4BC169"
            border
          >
            {filter(language === 'english' ? menu.items : menuFr.items, {
              object: 'page',
            }).map(item => (
              <StyledLink
                to={
                  item.object_slug === 'index'
                    ? `/${language === 'english' ? 'en' : 'fr'}`
                    : `/${item.object_slug}/${
                        language === 'english' ? 'en' : 'fr'
                      }`
                }
                activeStyle={{ textDecoration: 'underline' }}
              >
                {item.title}
              </StyledLink>
            ))}
            <StyledButton onClick={switchLang}>
              {language === 'english' ? 'Fr' : 'En'}
            </StyledButton>
            <StyledPre ml="auto">
              Countdown: <Countdown date={'April 12, 2019'} />
            </StyledPre>
          </DesktopToolbar>
          <MobileHide>
            <MobileNav
              menu={menu}
              location={location}
              language={language}
              switchLang={switchLang}
            />
          </MobileHide>
        </Border>

        <LogoFlex>
          <Flex
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            style={{ flexShrink: 0 }}
          >
            <Image width={'12rem'} mt={3} src={logo} />
            <Heading
              mx={3}
              my={3}
              fontSize={3}
              fontWeight={400}
              style={{ display: 'inline' }}
            >
              4–7 June 2019{' '}
              <Text mx={2} style={{ display: 'inline' }}>
                →
              </Text>{' '}
              Paris, France
            </Heading>
          </Flex>
          <Box
            bg="#4BC169"
            style={{ flexGrow: 1, position: 'relative', width: '100%' }}
          >
            <StyledBackgroundImage
              sizes={
                sample(filter(rotating_images, 'image.localFile')).image
                  .localFile.childImageSharp.sizes
              }
            />

            <Overlay />
            <OverlayGradient />
          </Box>
        </LogoFlex>

        <Border
          borderColor="#4BC169"
          borderLeft={0}
          borderRight={0}
          p={2}
          color="#999"
        >
          <TNOCFlex justifyContent="space-between" align="center" ml={3}>
            <Flex
              mx={'24px'}
              align="center"
              justifyContent="center"
              flexWrap="wrap"
            >
              <span> An event by </span>
              <NavLink
                fontWeight="400"
                color="#4BC169"
                href="https://www.thenatureofcities.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image src={tnoclogo} width={'1.5rem'} mx={1} my={0} /> The
                Nature of Cities
              </NavLink>
              <span> and </span>
              <NavLink
                fontWeight="400"
                color="#4BC169"
                href="https://www.thenatureofcities.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image src={tnocelogo} width={'1.5rem'} mx={1} my={0} /> The
                Nature of Cities — Europe
              </NavLink>
            </Flex>
            <Box mx={3}>{tagline}</Box>
          </TNOCFlex>
        </Border>
        <Newsletter />
      </Box>
    )
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js